import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    installed: false,
    mode: 'none'
  },
  mutations: {
    setInstalled(state,payload){
      state.installed = payload.installed
    },
    setMode(state,payload){
      state.mode = payload.mode
    }
  },
  actions: {
    init(){
      var data = {
        name: "getWebpageData"
      }
      window.postMessage(data, window.location.origin)
    },
    sendMode(_,payload){
      var data = {
        name: "setMode",
        mode: payload.mode
      }
      window.postMessage(data, window.location.origin)
    },
    sendRoomEnter(_,payload){
      var data = {
        name: "roomEnter",
        room: payload.roomName
      }
      window.postMessage(data, window.location.origin)
    },
    sendRoomLeave(){
      var data = {
        name: "roomLeave"
      }
      window.postMessage(data, window.location.origin)
    },
  },
  getters: {
    isRunning: (state) => () => {
      return state.speech.isRunning()
    },
  },
}
